import Breadcrumb from "../../components/common/Breadcrumb";
import RefundHeader from "../../components/Refund/RefundHeader";
import RefundList from "../../components/Refund/RefundList";

const RefundPage = () => {
  return (
    <div className="mt-3 ml-28 outlet-container">
      <Breadcrumb currentPage="Refund List" />
      <RefundHeader />
      <RefundList />
    </div>
  );
};

export default RefundPage;
